export default {
  title: "Filters",
  buttons: {
    gotoModules: "Modules"
  },
  labels: {
    search: "Search by name",
    select: "Select an Equipment",
    maintenance: "Maintenance",
    repair: "Repair",
    reliability: "Reliability",
    onetime: "Onetime Task",
    recurrent: "Recurrent Tasks",
    future: "Show future tasks",
    old: "Show old tasks",
    none: "None"
  }
};
